import React from 'react';
import PropTypes from 'prop-types';
import { Table, Menu, Icon, Loader, Header } from 'semantic-ui-react';
import _ from 'lodash';
import moment from 'moment';
import { CSVLink } from 'react-csv';

import AuditLogTableRow from '../../components/audit-log-table-row';
import CollaborationFeedItem from '../../components/collaboration-feed-item';

const tableStyle = {
  width: '100%',
};

const downloadCsvLinkStyle = {
  color: '#c71f7e',
  border: '1px solid #c71f7e',
  padding: '5px 15px',
  borderRadius: 6,
};

const loadingTableRowStyle = {
  height: 550,
};

const textCenteredStyle = {
  textAlign: 'center',
};

const buildCSVData = events => {
  const csvFields = ['time', 'user', 'action', 'assetUrl'];
  const data = _.map(events, event => [
    event.createdDate,
    event.createdBy,
    'added a new asset',
    event.messageData.resource ? event.messageData.resource.assetURL : '-',
  ]);
  return [csvFields, ...data];
};

const getCSVFileName = csvFileName => `${_.kebabCase(csvFileName)}-audit-${moment().utc().format()}.csv`;

const EmptyState = () => (
  <Table.Body>
    <Table.Row style={loadingTableRowStyle}>
      <Table.Cell colSpan={5} style={textCenteredStyle}>
        <Header icon >
          <Icon name="wait outline" color="orange" />
          No events yet
        </Header>
      </Table.Cell>
    </Table.Row>
  </Table.Body>

);

const LoadingTableBody = () => (
  <Table.Body>
    <Table.Row style={loadingTableRowStyle}>
      <Table.Cell colSpan={5}>
        <Loader
          active
          content="Loading feed..."
          inline="centered"
        />
      </Table.Cell>
    </Table.Row>
  </Table.Body>
);

const FeedTypeTable = ({
  events,
  hasExportFeature,
  csvFileName,
  isLoading,
  isCollaborationMode,
}) => {
  const csvData = buildCSVData(events);
  return (
    <div>
      {
        hasExportFeature && !isLoading && !_.isEmpty(events) &&
        <Menu pointing>
          <Menu.Menu position="right">
            <Menu.Item>
              <CSVLink
                style={downloadCsvLinkStyle}
                filename={getCSVFileName(csvFileName)}
                data={csvData}
              ><Icon name="file excel outline" /> export as csv</CSVLink>
            </Menu.Item>
          </Menu.Menu>
        </Menu>
      }
      <Table celled style={tableStyle}>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Time</Table.HeaderCell>
            { !isCollaborationMode && <Table.HeaderCell>User</Table.HeaderCell> }
            <Table.HeaderCell>Action</Table.HeaderCell>
            { !isCollaborationMode && <Table.HeaderCell>Campaign</Table.HeaderCell> }
            { !isCollaborationMode && <Table.HeaderCell>Link</Table.HeaderCell> }
          </Table.Row>
        </Table.Header>
        {
          isLoading &&
          <LoadingTableBody />
        }
        {
          !isLoading &&
            <Table.Body>
              { _.map(events, event => (isCollaborationMode ? <CollaborationFeedItem {...event} /> : <AuditLogTableRow {...event} />)) }
            </Table.Body>
        }
        {
          !isLoading && _.isEmpty(events) &&
          <EmptyState />
        }
      </Table>
    </div>
  );
};

FeedTypeTable.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  events: PropTypes.array.isRequired,
  hasExportFeature: PropTypes.bool,
  csvFileName: PropTypes.string,
  isCollaborationMode: PropTypes.bool,
};

FeedTypeTable.defaultProps = {
  hasExportFeature: false,
  isCollaborationMode: false,
  csvFileName: 'audit',
};

export default FeedTypeTable;



/** WEBPACK FOOTER **
 ** ./src/containers/event-feed/feed-type-table.js
 **/